// PreviewTester/utils/selectorRecalculator.js

function parsePath(path) {
  console.log('RECALCULATION RELATED TRACKINGS:: parsePath called with:', { path });
  if (!path) return [];
  return path.split(' > ').map(part => {
    const match = part.match(/^([a-zA-Z]+):nth-child\((\d+)\)$/);
    if (match) {
      return { tag: match[1], index: parseInt(match[2]) };
    }
    return { tag: part, index: 1 };
  });
}

function buildPath(parts) {
  console.log('RECALCULATION RELATED TRACKINGS:: buildPath called with:', { parts });
  return parts.map(p => `${p.tag}:nth-child(${p.index})`).join(' > ');
}

class SelectorTracker {
  constructor() {
    console.log('RECALCULATION RELATED TRACKINGS:: SelectorTracker constructor called with:', {});
    this.changes = [];
    this.currentIndex = 0;
  }

  recordChange(change) {
    console.log('RECALCULATION RELATED TRACKINGS:: recordChange called with:', { change });
    this.changes.push({
      ...change,
      id: this.currentIndex++,
      timestamp: Date.now()
    });
  }

  clearChanges() {
    console.log('RECALCULATION RELATED TRACKINGS:: clearChanges called with:', {});
    this.changes = [];
    this.currentIndex = 0;
  }

  getChanges() {
    console.log('RECALCULATION RELATED TRACKINGS:: getChanges called with:', {});
    return this.changes;
  }

  hasChanges() {
    console.log('RECALCULATION RELATED TRACKINGS:: hasChanges called with:', {});
    return this.changes.length > 0;
  }
}

// ============================================================
// Helper: Get path from selector (supports both old and new formats)
// ============================================================
function getSelectorPath(selector, type = 'start') {
  if (!selector) return '';
  
  // New format: selector is a string or has start/end as strings
  if (typeof selector === 'string') {
    return selector;
  }
  
  if (typeof selector === 'object') {
    // New format: { start: "path", end: "path", loopSelector: "path" }
    if (type === 'start' && selector.start && typeof selector.start === 'string') {
      return selector.start;
    }
    if (type === 'end' && selector.end && typeof selector.end === 'string') {
      return selector.end;
    }
    if (type === 'loopSelector' && selector.loopSelector && typeof selector.loopSelector === 'string') {
      return selector.loopSelector;
    }
    
    // Old format: { start: { elementPath: "path" }, end: { elementPath: "path" } }
    if (type === 'start' && selector.start && selector.start.elementPath) {
      return selector.start.elementPath;
    }
    if (type === 'end' && selector.end && selector.end.elementPath) {
      return selector.end.elementPath;
    }
    if (type === 'loopSelector' && selector.loopSelector) {
      return selector.loopSelector;
    }
  }
  
  return '';
}

// ============================================================
// Helper: Normalize selector to new format
// ============================================================
function normalizeSelector(selector) {
  if (!selector) return null;
  
  // If already in new format (start and end are strings)
  if (typeof selector.start === 'string' && typeof selector.end === 'string') {
    return {
      start: selector.start,
      end: selector.end,
      ...(selector.loopSelector ? { loopSelector: selector.loopSelector } : {})
    };
  }
  
  // Convert from old format
  const startPath = getSelectorPath(selector, 'start');
  const endPath = getSelectorPath(selector, 'end');
  const loopSelector = getSelectorPath(selector, 'loopSelector');
  
  return {
    start: startPath,
    end: endPath,
    ...(loopSelector ? { loopSelector: loopSelector } : {})
  };
}

// ============================================================
// calculateShifts - Determines how target selector indices shift
// ============================================================
function calculateShifts(targetPath, newItem) {
  console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts called with:', { targetPath, newItem });

  console.log("targetPathtargetPath", targetPath);
  console.log("newItemnewItem", newItem);

  const shifts = [];

  // ✅ Guard against empty targetPath
  if (!targetPath) {
    console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - empty targetPath, returning');
    return shifts;
  }

  const targetParts = parsePath(targetPath);
  console.log("targetPartstargetParts-----------", targetParts);
  
  if (targetParts.length === 0) {
    console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - empty target, returning');
    return shifts;
  }

  // ============================================================
  // CASE 0: UPDATE OPERATION
  // ============================================================
  if (newItem.type === 'update') {
    console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - processing UPDATE');

    const updatePath = newItem.start_path || newItem.end_path;
    if (!updatePath) {
      console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - no updatePath');
      return shifts;
    }

    const updateParts = parsePath(updatePath);
    console.log("updatePartsupdateParts", updateParts);
    
    if (updateParts.length === 0) {
      console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - empty updateParts');
      console.log("shiftsshiftsshifts not calling here", shifts);
      return shifts;
    }

    // Check if target is INSIDE the updated element
    let commonPrefixLength = 0;
    const minLength = Math.min(targetParts.length, updateParts.length);

    console.log("minLengthminLengthminLength", minLength);
    console.log("commonPrefixLengthcommonPrefixLength222", commonPrefixLength);

    for (let i = 0; i < minLength; i++) {
      console.log("targetParts[i].tag === updateParts[i].tag && targetParts[i].index === updateParts[i].index", targetParts[i].tag === updateParts[i].tag && targetParts[i].index === updateParts[i].index);
      
      if (targetParts[i].tag === updateParts[i].tag && targetParts[i].index === updateParts[i].index) {
        console.log("commonPrefixLengthcommonPrefixLength", commonPrefixLength);
        commonPrefixLength++;
        console.log("commonPrefixLengthcommonPrefixLength1111", commonPrefixLength);
      } else {
        break;
      }
    }
    console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - commonPrefixLength:', commonPrefixLength);

    // If update path is a PREFIX of target path, the target is INSIDE the updated element
    const updateIsPrefix = commonPrefixLength === updateParts.length && targetParts.length > updateParts.length;
    console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - updateIsPrefix:', updateIsPrefix);

    if (updateIsPrefix) {
      const targetDepth = targetParts.length - updateParts.length;
      console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - targetDepth:', targetDepth);
      
      if (targetDepth === 1) {
        console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - target is direct child of updated element');
        const targetLeaf = targetParts[targetParts.length - 1];
        if (targetLeaf.tag === 'span' || targetLeaf.tag === 'div') {
          console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - target is span/div, marking as deleted');
          return { targetDeleted: true, reason: 'update_removed_child_element' };
        }
      } else if (targetDepth > 1) {
        console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - target is deeper, marking as deleted');
        return { targetDeleted: true, reason: 'update_removed_nested_element' };
      }
    }

    if (targetPath === updatePath) {
      console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - targetPath === updatePath');
      return shifts;
    }

    console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - UPDATE result: no shift or target deleted');
    return shifts;
  }

  // ============================================================
  // CASE 1: DELETE OPERATION
  // ============================================================
  if (newItem.type === 'delete') {
    console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - processing DELETE');

    const deletedPath = newItem.selectorPath || newItem.start_path;
    if (!deletedPath) {
      console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - no deletedPath');
      return shifts;
    }

    const deletedParts = parsePath(deletedPath);
    console.log(deletedParts.length, "deletedPartsdeletedParts", deletedParts);
    
    if (deletedParts.length === 0) {
      console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - empty deletedParts');
      return shifts;
    }

    if (targetPath === deletedPath) {
      console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - targetPath === deletedPath, target deleted');
      return { targetDeleted: true };
    }

    let commonPrefixLength = 0;
    console.log("targetParts.length", targetParts.length);
    console.log("deletedParts.length", deletedParts.length);
    const minLength = Math.min(targetParts.length, deletedParts.length);
    console.log("minLengthminLength", minLength);

    for (let i = 0; i < minLength; i++) {
      if (targetParts[i].tag === deletedParts[i].tag && targetParts[i].index === deletedParts[i].index) {
        console.log("targetParts[i].tag === deletedParts[i].tag111", targetParts[i].tag === deletedParts[i].tag);
        console.log("targetParts[i].index === deletedParts[i].index111", targetParts[i].index === deletedParts[i].index);
        commonPrefixLength++;
      } else {
        break;
      }
    }
    console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - commonPrefixLength:', commonPrefixLength);

    if (commonPrefixLength === 0) {
      console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - no common prefix, no shift');
      return shifts;
    }

    const deletedIsPrefix = commonPrefixLength === deletedParts.length && targetParts.length > deletedParts.length;
    const targetIsPrefix = commonPrefixLength === targetParts.length && deletedParts.length > targetParts.length;
    const pathsDiverge = commonPrefixLength < Math.min(targetParts.length, deletedParts.length);
    console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - deletedIsPrefix:', deletedIsPrefix, 'targetIsPrefix:', targetIsPrefix, 'pathsDiverge:', pathsDiverge);

    let leafToShift;

    if (deletedIsPrefix) {
      console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - deletedIsPrefix, target is inside deleted ancestor, target deleted');
      return { targetDeleted: true };
    } else if (targetIsPrefix) {
      console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - targetIsPrefix, no shift');
      return shifts;
    } else if (pathsDiverge) {
      const targetParentIdx = commonPrefixLength - 1;
      const deletedParentIdx = commonPrefixLength - 1;

      console.log(deletedParentIdx, "heydffdgfd", targetParentIdx);

      if (targetParentIdx >= 0 && deletedParentIdx >= 0) {
        const targetParent = targetParts[targetParentIdx];
        const deletedParent = deletedParts[deletedParentIdx];

        console.log(deletedParent, "deletedParent targetParent", targetParent);

        if (targetParent.tag === deletedParent.tag && targetParent.index === deletedParent.index) {
          console.log(targetParent, deletedParent, "targetParent.tag === deletedParent.tag", targetParent.tag === deletedParent.tag);
          console.log(targetParent, deletedParent, "targetParent.index === deletedParent.index", targetParent.index === deletedParent.index);

          if (deletedParts.length > targetParts.length) {
            console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - deleted deeper, no shift');
            return shifts;
          }
          console.log(targetParts, "targetPartstargetPartsdfhgjfd", targetParts.length, commonPrefixLength);
          leafToShift = targetParts.length - 1 - commonPrefixLength;
          console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - pathsDiverge, leafToShift:', leafToShift);
        } else {
          console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - different parents, no shift');
          return shifts;
        }
      } else {
        console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - invalid parent indices');
        return shifts;
      }
    } else {
      console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - no condition met');
      return shifts;
    }

    if (leafToShift === undefined) return shifts;

    leafToShift = Math.max(0, Math.min(leafToShift, targetParts.length - 1));
    console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - clamped leafToShift:', leafToShift);

    console.log("targetPartstargetParts............", targetParts.length - 1 - leafToShift);
    
    const partIdx = targetParts.length - 1 - leafToShift;
    if (partIdx >= 0 && partIdx < targetParts.length) {
      const deletedPartAtLevel = deletedParts[Math.min(partIdx, deletedParts.length - 1)];
      const deletedPosition = deletedPartAtLevel ? deletedPartAtLevel.index : 1;
      const currentValue = targetParts[partIdx].index;
      console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - partIdx:', partIdx, 'deletedPosition:', deletedPosition, 'currentValue:', currentValue);

      if (currentValue > deletedPosition) {
        shifts.push({ leafIdx: leafToShift, delta: -1 });
        console.log("shiftsshifts", shifts);
        console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - shift pushed:', { leafIdx: leafToShift, delta: -1 });
      }
    }

    console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - DELETE result:', shifts);
    return shifts;
  }

  // ============================================================
  // CASE 2: ADD OPERATION
  // ============================================================
  if (newItem.type === 'add') {
    console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - processing ADD');
    console.log("targetPartstargetParts-----------111111", targetParts);
    
    const newItemPath = newItem.start_path || newItem.end_path;
    if (!newItemPath) {
      console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - no newItemPath');
      return shifts;
    }

    console.log("newItemPathnewItemPath,newItemPath", newItemPath);
    
    const newItemParts = parsePath(newItemPath);
    if (newItemParts.length === 0) {
      console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - empty newItemParts');
      return shifts;
    }
    console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - newItemParts:', newItemParts);

    let commonPrefixLength = 0;
    console.log(targetParts.length, "targetParts.length....");
    console.log(newItemParts.length, "newItemParts.length....");

    const minLength = Math.min(targetParts.length, newItemParts.length);
    console.log(targetParts.length, "minLength....", minLength);

    for (let i = 0; i < minLength; i++) {
      if (targetParts[i].tag === newItemParts[i].tag && targetParts[i].index === newItemParts[i].index) {
        commonPrefixLength++;
      } else {
        break;
      }
    }
    console.log(shifts, "commonPrefixLength---", commonPrefixLength, newItemParts);
    
    console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - commonPrefixLength:', commonPrefixLength);

    if (commonPrefixLength === 0) {
      console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - no common prefix, no shift');
      return shifts;
    }

    const isAncestorAddition = commonPrefixLength === newItemParts.length && targetParts.length > newItemParts.length;
    const sameLength = newItemParts.length === targetParts.length;
    const sameImmediateParent = sameLength && commonPrefixLength >= targetParts.length - 1;
    console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - isAncestorAddition:', isAncestorAddition, 'sameImmediateParent:', sameImmediateParent);

    if (isAncestorAddition) {
      console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - Case A: ancestor addition');
      const newPosition = newItemParts[newItemParts.length - 1].index;
      const targetPosition = targetParts[newItemParts.length - 1].index;
      console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - newPosition:', newPosition, 'targetPosition:', targetPosition);

      if (newPosition <= targetPosition) {
        const leafIdx = targetParts.length - newItemParts.length;
        shifts.push({ leafIdx: Math.max(0, leafIdx), delta: 1 });
        console.log("leafIdxleafIdx", leafIdx);
        console.log("shifts........", shifts);
        console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - shift pushed:', { leafIdx: Math.max(0, leafIdx), delta: 1 });
      }
      return shifts;
    }

    if (!isAncestorAddition && commonPrefixLength >= 1 && newItemParts.length < targetParts.length) {
      console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - Case A2: divergent paths');
      const divergenceLevel = commonPrefixLength;
      const newPosition = newItemParts[divergenceLevel].index;
      const targetPosition = targetParts[divergenceLevel].index;
      console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - divergenceLevel:', divergenceLevel, 'newPosition:', newPosition, 'targetPosition:', targetPosition);

      const parentLevel = commonPrefixLength - 1;
      if (parentLevel >= 0) {
        const newItemParent = newItemParts[parentLevel];
        const targetParent = targetParts[parentLevel];
        console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - newItemParent:', newItemParent, 'targetParent:', targetParent);

        if (newItemParent.tag === targetParent.tag && newItemParent.index === targetParent.index) {
          if (newPosition <= targetPosition) {
            const leafIdx = targetParts.length - 1 - divergenceLevel;
            shifts.push({ leafIdx: Math.max(0, leafIdx), delta: 1 });
            console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - shift pushed:', { leafIdx: Math.max(0, leafIdx), delta: 1 });
          }
        }
      }
      return shifts;
    }

    if (sameImmediateParent) {
      console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - Case B: same level addition');
      const targetIndex = targetParts[targetParts.length - 1].index;
      const addedIndex = newItemParts[newItemParts.length - 1].index;
      console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - targetIndex:', targetIndex, 'addedIndex:', addedIndex);

      if (addedIndex <= targetIndex) {
        shifts.push({ leafIdx: 0, delta: 1 });
        console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - shift pushed:', { leafIdx: 0, delta: 1 });
      }
      return shifts;
    }

    console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - no applicable case, no shift');
    return shifts;
  }

  console.log("shifts-----------", shifts);
  console.log('RECALCULATION RELATED TRACKINGS:: calculateShifts - unknown type, returning');
  return shifts;
}

// ============================================================
// applyChangeToPathsToArrayOfTargetSelectors - Apply a single change to an array of selectors
// ============================================================
function applyChangeToPathsToArrayOfTargetSelectors(targetSelectorsArray, newItem) {
  console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPathsToArrayOfTargetSelectors called with: targetSelectorsArray', JSON.stringify(targetSelectorsArray), newItem);

  if (!targetSelectorsArray || targetSelectorsArray.length === 0) {
    return [];
  }

  const results = [];

  for (let i = 0; i < targetSelectorsArray.length; i++) {
    const selector = targetSelectorsArray[i];

    console.log("selectorselector", selector, "-------", selector.loopSelector);

    if (!selector) {
      console.log(`RECALCULATION RELATED TRACKINGS:: ⚠️ Selector ${i + 1} is null/undefined, skipping`);
      continue;
    }

    // Normalize selector to new format
    const normalizedSelector = normalizeSelector(selector);
    if (!normalizedSelector) {
      console.log(`RECALCULATION RELATED TRACKINGS:: ⚠️ Selector ${i + 1} could not be normalized, skipping`);
      continue;
    }

    const startPath = normalizedSelector.start || '';
    const endPath = normalizedSelector.end || '';
    const loopSelector = normalizedSelector.loopSelector || '';

    if (!startPath && !endPath) {
      console.log(`RECALCULATION RELATED TRACKINGS:: ⚠️ Selector ${i + 1} has no paths, skipping`);
      continue;
    }

    // ============================================================
    // CRITICAL: Check if this is a loop selector
    // ============================================================
    if (loopSelector) {
      console.log(`RECALCULATION RELATED TRACKINGS:: 🔄 Selector ${i + 1} has loopSelector, forwarding to applyChangeToPaths`);

      const result = applyChangeToPaths(
        {
          loopSelector: loopSelector,
          start: startPath,
          end: endPath
        },
        newItem
      );

      if (result && result.targetDeleted === true) {
        console.log(`RECALCULATION RELATED TRACKINGS:: 🗑️ Selector ${i + 1} target was deleted, removing from array`);
        continue;
      }

      if (result && result.loopSelectorDeleted === true) {
        console.log(`RECALCULATION RELATED TRACKINGS:: 🗑️ Loop container for selector ${i + 1} was deleted, removing selector`);
        continue;
      }

      const updatedSelector = {
        ...normalizedSelector,
        loopSelector: result?.loopSelector || loopSelector,
        start: result?.start || startPath,
        end: result?.end || endPath
      };

      console.log("updatedSelector", updatedSelector);
      results.push(updatedSelector);
      console.log("resultsresults...", results);
      console.log(`RECALCULATION RELATED TRACKINGS:: ✅ Selector ${i + 1} updated: loopSelector=${updatedSelector.loopSelector}, start=${updatedSelector.start}, end=${updatedSelector.end}`);
      continue;
    }

    // ============================================================
    // EXISTING LOGIC: Regular absolute selector
    // ============================================================
    const result = applyChangeToPaths(
      {
        start: startPath,
        end: endPath
      },
      newItem
    );

    if (result && result.targetDeleted === true) {
      console.log(`RECALCULATION RELATED TRACKINGS:: 🗑️ Selector ${i + 1} was deleted, removing from array`);
      continue;
    }

    if (result && result.start) {
      const updatedSelector = {
        ...normalizedSelector,
        start: result.start,
        end: result.end || result.start
      };
      results.push(updatedSelector);
      console.log(`RECALCULATION RELATED TRACKINGS:: ✅ Selector ${i + 1} updated: ${result.start}`);
    } else {
      results.push({ ...normalizedSelector });
      console.log(`RECALCULATION RELATED TRACKINGS:: ⏭️ Selector ${i + 1} unchanged`);
    }
  }

  console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPathsToArrayOfTargetSelectors result:', {
    inputCount: targetSelectorsArray.length,
    outputCount: results.length
  });

  return results;
}


// ============================================================
// calculateShiftsForLoopSelector - Determines shifts for loopSelector format
// ============================================================
function calculateShiftsForLoopSelector(targetSelectors, newItem) {
  console.log(
    "RECALCULATION RELATED TRACKINGS:: calculateShiftsForLoopSelector called with:",
    { targetSelectors, newItem },
  );

  // ============================================================
  // ✅ DEV-ONLY GUARD — 2C
  // INVARIANT: The three paths have a strict relationship:
  //              • loopSelector is ABSOLUTE (relative to
  //                .item-ui-screen) → starts with the wrapper
  //                prefix `div:nth-child(1)`.
  //              • start / end are RELATIVE to loopSelector.
  //              • Concatenating loopSelector + " > " + start must
  //                yield a valid absolute path (i.e. 4+ segments
  //                with the wrapper > contentWraps prefix).
  //
  // A violation here silently no-ops recalculation: the shift
  // engine concatenates the paths, compares them to a change
  // path, and either mis-matches or mis-shifts. The user sees
  // their edits not propagate to transformations.
  //
  // Owned by: generateSelectorPathForRow in TemplateEditor.js +
  //           getRelativePath / getNthChildPath in renderingUtils.js.
  // ============================================================
  if (process.env.NODE_ENV !== "production") {
    const ls = targetSelectors?.loopSelector || "";
    const st = targetSelectors?.start || "";
    const en = targetSelectors?.end || "";

    const ABS_PREFIX_RE =
      /^div:nth-child\(\d+\)\s*>\s*div:nth-child\(\d+\)\s*>\s*div:nth-child\(\d+\)\s*>\s*div:nth-child\(\d+\)/;

    if (ls && !ls.startsWith("div:nth-child(1)")) {
      console.warn(
        "[INVARIANT:2C] calculateShiftsForLoopSelector: loopSelector does not start with the wrapper segment.",
        { loopSelector: ls, change: newItem?.type, targetSelectors },
      );
    }

    if (st && ABS_PREFIX_RE.test(st)) {
      console.warn(
        "[INVARIANT:2C] calculateShiftsForLoopSelector: start looks absolute, expected relative to loopSelector.",
        { loopSelector: ls, start: st },
      );
    }

    if (en && ABS_PREFIX_RE.test(en)) {
      console.warn(
        "[INVARIANT:2C] calculateShiftsForLoopSelector: end looks absolute, expected relative to loopSelector.",
        { loopSelector: ls, end: en },
      );
    }

    // Sanity: the loopSelector's segment count should be 3 or 5
    // (3 for Case 1/3 outer-loop-stripped, 5 for Case 2 or nested).
    if (ls) {
      const lsSegs = ls.split(" > ").length;
      if (lsSegs !== 3 && lsSegs !== 5) {
        console.warn(
          "[INVARIANT:2C] calculateShiftsForLoopSelector: loopSelector has unexpected segment count.",
          {
            loopSelector: ls,
            lsSegs,
            expected: "3 (outer-loop-stripped) or 5 (nested)",
          },
        );
      }
    }

    // If both start and end are present but empty, the step is
    // effectively dead — the shift engine will never produce a
    // meaningful relative shift.
    if (!st || !en) {
      console.warn(
        "[INVARIANT:2C] calculateShiftsForLoopSelector: start or end is empty.",
        { loopSelector: ls, start: st, end: en, change: newItem?.type },
      );
    }
  }

  const result = {
    loopSelector: targetSelectors.loopSelector || "",
    start: targetSelectors.start || "",
    end: targetSelectors.end || "",
    loopSelectorDeleted: false,
    targetDeleted: false,
  };

  // ============================================================
  // HANDLE MOVE OPERATION - delegate to absolute path move logic
  // ============================================================
  if (newItem.type === "move") {
    console.log(
      "RECALCULATION RELATED TRACKINGS:: MOVE operation detected",
    );

    const absoluteStart = result.loopSelector + " > " + result.start;
    const absoluteEnd = result.loopSelector + " > " + result.end;

    console.log(absoluteEnd, "absoluteStart", absoluteStart);

    const moveResult = applyChangeToPaths(
      { start: absoluteStart, end: absoluteEnd },
      newItem,
    );

    console.log("moveResultmoveResult", moveResult);

    if (moveResult && moveResult.targetDeleted === true) {
      result.targetDeleted = true;
      return result;
    }

    if (moveResult && moveResult.start) {
      const resultParts = parsePath(moveResult.start);
      const loopParts = parsePath(result.loopSelector);

      const newLoopParts = resultParts.slice(0, loopParts.length);
      const newLoopSelector = buildPath(newLoopParts);

      const relativeParts = resultParts.slice(loopParts.length);
      const newRelativeStart =
        relativeParts.length > 0 ? buildPath(relativeParts) : result.start;

      result.loopSelector = newLoopSelector;
      result.start = newRelativeStart;

      const endResultParts = parsePath(moveResult.end);
      const endRelativeParts = endResultParts.slice(loopParts.length);
      result.end =
        endRelativeParts.length > 0 ? buildPath(endRelativeParts) : result.end;

      console.log(
        "RECALCULATION RELATED TRACKINGS:: MOVE result:",
        result,
      );
      return result;
    }

    return result;
  }

  // ============================================================
  // EXISTING ADD/DELETE LOGIC
  // ============================================================

  const loopTargetPath = result.loopSelector;
  const newItemPath =
    newItem.start_path || newItem.end_path || newItem.selectorPath;

  if (!newItemPath) {
    return result;
  }

  const loopParts = parsePath(loopTargetPath);
  const newItemParts = parsePath(newItemPath);

  let loopAffected = false;
  let relativeAffected = false;

  let commonPrefix = 0;
  const minLength = Math.min(loopParts.length, newItemParts.length);
  for (let i = 0; i < minLength; i++) {
    if (
      newItemParts[i].tag === loopParts[i].tag &&
      newItemParts[i].index === loopParts[i].index
    ) {
      commonPrefix++;
    } else {
      break;
    }
  }

  console.log(
    "RECALCULATION RELATED TRACKINGS:: commonPrefix:",
    commonPrefix,
  );

  if (
    commonPrefix === newItemParts.length &&
    newItemParts.length <= loopParts.length
  ) {
    loopAffected = true;

    if (newItemParts.length === loopParts.length && newItem.type === "delete") {
      result.loopSelectorDeleted = true;
      console.log(
        "RECALCULATION RELATED TRACKINGS:: loopSelector itself is being deleted",
      );
    } else {
      console.log(
        "RECALCULATION RELATED TRACKINGS:: ancestor addition affecting loopSelector",
      );
    }
  } else if (
    commonPrefix === loopParts.length &&
    newItemParts.length > loopParts.length
  ) {
    relativeAffected = true;
    console.log(
      "RECALCULATION RELATED TRACKINGS:: newItem is inside the loop",
    );
  } else if (commonPrefix > 0 && commonPrefix < minLength) {
    const divergenceLevel = commonPrefix;
    const parentLevel = divergenceLevel - 1;

    console.log(
      "RECALCULATION RELATED TRACKINGS:: paths diverge at level:",
      divergenceLevel,
      "parentLevel:",
      parentLevel,
    );

    if (parentLevel >= 0) {
      if (
        newItemParts[parentLevel].tag === loopParts[parentLevel].tag &&
        newItemParts[parentLevel].index === loopParts[parentLevel].index
      ) {
        const newItemIndex = newItemParts[divergenceLevel].index;
        const loopIndex = loopParts[divergenceLevel].index;

        console.log(
          "RECALCULATION RELATED TRACKINGS:: same parent - siblings! newItemIndex:",
          newItemIndex,
          "loopIndex:",
          loopIndex,
        );

        if (newItem.type === "delete" && newItemIndex < loopIndex) {
          loopAffected = true;
          console.log(
            "RECALCULATION RELATED TRACKINGS:: delete before loopSelector - loop affected",
          );
        } else if (newItem.type === "add" && newItemIndex <= loopIndex) {
          loopAffected = true;
          console.log(
            "RECALCULATION RELATED TRACKINGS:: add before/at loopSelector - loop affected",
          );
        } else if (newItem.type === "delete" && newItemIndex > loopIndex) {
          console.log(
            "RECALCULATION RELATED TRACKINGS:: delete after loopSelector - loop NOT affected",
          );
        } else if (newItem.type === "add" && newItemIndex > loopIndex) {
          console.log(
            "RECALCULATION RELATED TRACKINGS:: add after loopSelector - loop NOT affected",
          );
        }
      } else {
        console.log(
          "RECALCULATION RELATED TRACKINGS:: different parents - unrelated",
        );
      }
    }
  } else if (commonPrefix === 0) {
    console.log(
      "RECALCULATION RELATED TRACKINGS:: no common prefix - unrelated",
    );
  }

  console.log(
    "RECALCULATION RELATED TRACKINGS:: loopAffected:",
    loopAffected,
    "relativeAffected:",
    relativeAffected,
  );

  if (loopAffected && !result.loopSelectorDeleted) {
    const loopShifts = calculateShifts(loopTargetPath, newItem);

    console.log(
      "RECALCULATION RELATED TRACKINGS:: loopShifts:",
      loopShifts,
    );

    if (loopShifts && loopShifts.targetDeleted === true) {
      result.loopSelectorDeleted = true;
      return result;
    }

    if (loopShifts.length > 0) {
      const parts = parsePath(loopTargetPath);
      for (const shift of loopShifts) {
        const partIdx = parts.length - 1 - shift.leafIdx;
        if (partIdx >= 0 && partIdx < parts.length) {
          parts[partIdx].index += shift.delta;
          if (parts[partIdx].index < 1) parts[partIdx].index = 1;
        }
      }
      result.loopSelector = buildPath(parts);
      console.log(
        "RECALCULATION RELATED TRACKINGS:: updated loopSelector:",
        result.loopSelector,
      );
    }
  }

  if (relativeAffected) {
    const absoluteStart = result.loopSelector + " > " + result.start;
    const absoluteEnd = result.loopSelector + " > " + result.end;

    console.log(
      "RECALCULATION RELATED TRACKINGS:: constructed absolute start:",
      absoluteStart,
    );

    const relativeShifts = calculateShifts(absoluteStart, newItem);

    console.log(
      "RECALCULATION RELATED TRACKINGS:: relativeShifts:",
      relativeShifts,
    );

    if (relativeShifts && relativeShifts.targetDeleted === true) {
      result.targetDeleted = true;
      return result;
    }

    if (relativeShifts.length > 0) {
      const loopPartsLength = parsePath(result.loopSelector).length;

      let startParts = parsePath(absoluteStart);
      for (const shift of relativeShifts) {
        const partIdx = startParts.length - 1 - shift.leafIdx;
        if (partIdx >= 0 && partIdx < startParts.length) {
          startParts[partIdx].index += shift.delta;
          if (startParts[partIdx].index < 1) startParts[partIdx].index = 1;
        }
      }

      const relativeStartParts = startParts.slice(loopPartsLength);
      result.start =
        relativeStartParts.length > 0 ? buildPath(relativeStartParts) : "";

      let endParts = parsePath(absoluteEnd);
      for (const shift of relativeShifts) {
        const partIdx = endParts.length - 1 - shift.leafIdx;
        if (partIdx >= 0 && partIdx < endParts.length) {
          endParts[partIdx].index += shift.delta;
          if (endParts[partIdx].index < 1) endParts[partIdx].index = 1;
        }
      }

      const relativeEndParts = endParts.slice(loopPartsLength);
      result.end =
        relativeEndParts.length > 0 ? buildPath(relativeEndParts) : "";

      console.log(
        "RECALCULATION RELATED TRACKINGS:: updated relative start:",
        result.start,
      );
      console.log(
        "RECALCULATION RELATED TRACKINGS:: updated relative end:",
        result.end,
      );
    }
  }

  // ============================================================
  // ✅ DEV-ONLY GUARD — 2C (post-computation)
  // INVARIANT: After the shift computation, result.loopSelector
  //            MUST still be absolute (starts with wrapper),
  //            and result.start / result.end MUST NOT have
  //            become absolute (they must remain relative to the
  //            loop).
  //
  // Reason: the MOVE branch and the relativeAffected branch both
  // rebuild paths via buildPath. If a slicing mistake slips
  // through, the loop prefix could be stripped from start/end, or
  // the loop could lose its wrapper prefix. Either condition
  // silently breaks the next recalculation pass.
  // ============================================================
  if (process.env.NODE_ENV !== "production") {
    const lsOut = result.loopSelector || "";
    const stOut = result.start || "";
    const enOut = result.end || "";

    if (lsOut && !lsOut.startsWith("div:nth-child(1)")) {
      console.warn(
        "[INVARIANT:2C] calculateShiftsForLoopSelector: result.loopSelector lost its wrapper prefix.",
        { original: targetSelectors?.loopSelector, result: lsOut },
      );
    }

    const ABS_PREFIX_RE =
      /^div:nth-child\(\d+\)\s*>\s*div:nth-child\(\d+\)\s*>\s*div:nth-child\(\d+\)\s*>\s*div:nth-child\(\d+\)/;

    if (stOut && ABS_PREFIX_RE.test(stOut)) {
      console.warn(
        "[INVARIANT:2C] calculateShiftsForLoopSelector: result.start became absolute after shift.",
        { result: stOut, original: targetSelectors?.start },
      );
    }
    if (enOut && ABS_PREFIX_RE.test(enOut)) {
      console.warn(
        "[INVARIANT:2C] calculateShiftsForLoopSelector: result.end became absolute after shift.",
        { result: enOut, original: targetSelectors?.end },
      );
    }
  }

  console.log(
    "RECALCULATION RELATED TRACKINGS:: calculateShiftsForLoopSelector result:",
    result,
  );
  return result;
}

// ============================================================
// applyChangeToPaths - Apply a change to target selectors
// Handles both absolute paths and loopSelector format
// ============================================================
function applyChangeToPaths(targetSelectors, newItem) {
  console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths called with:', JSON.stringify({ targetSelectors, newItem }));

  // ============================================================
  // NEW: Handle loopSelector format (inside loop case)
  // ============================================================
  if (targetSelectors && targetSelectors.loopSelector) {
    console.log('RECALCULATION RELATED TRACKINGS:: 🔄 LoopSelector detected, handling inside-loop case');
    console.log('RECALCULATION RELATED TRACKINGS:: loopSelector:', targetSelectors.loopSelector);
    console.log('RECALCULATION RELATED TRACKINGS:: relative start:', targetSelectors.start, 'relative end:', targetSelectors.end);

    const result = calculateShiftsForLoopSelector(targetSelectors, newItem);

    console.log("resultresult", result);

    if (result.targetDeleted) {
      console.log('RECALCULATION RELATED TRACKINGS:: 🗑️ Target element was deleted');
      return { targetDeleted: true };
    }

    if (result.loopSelectorDeleted) {
      console.log('RECALCULATION RELATED TRACKINGS:: 🗑️ Loop container deleted, returning unchanged paths');
      return {
        loopSelector: targetSelectors.loopSelector,
        start: targetSelectors.start,
        end: targetSelectors.end
      };
    }

    const finalResult = {
      loopSelector: result.loopSelector,
      start: result.start,
      end: result.end
    };

    console.log('RECALCULATION RELATED TRACKINGS:: loopSelector final result:', finalResult);
    return finalResult;
  }

  // ============================================================
  // EXISTING: Handle absolute path format (outside loop case)
  // ============================================================
  const result = { start: targetSelectors.start || '', end: targetSelectors.end || '' };

  if (!result.start && !result.end) {
    console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - missing selectors, returning:', result);
    return result;
  }

  console.log("1111111result", result);
  
  // ============================================================
  // HANDLE MOVE OPERATION
  // ============================================================
  if (newItem.type === 'move') {
    console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - processing MOVE operation');
    console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - move start_path:', newItem.start_path, 'end_path:', newItem.end_path);

    console.log("newItemnewItem---", newItem);
    
    const deleteItem = {
      type: 'delete',
      selectorPath: newItem.start_path,
      start_path: newItem.start_path,
      end_path: newItem.start_path
    };

    console.log(result.start, "deleteItemdeleteItem-----", deleteItem);
    
    const deleteShifts = calculateShifts(result.start, deleteItem);
    console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - deleteShifts:', deleteShifts);

    if (deleteShifts && deleteShifts.targetDeleted === true) {
      console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - target itself is being moved');

      const moveStartParts = parsePath(newItem.start_path);
      const targetStartParts = parsePath(result.start);
      const targetEndParts = parsePath(result.end);
      const endPathParts = parsePath(newItem.end_path);

      console.log("paths-------", moveStartParts, targetStartParts, targetEndParts, endPathParts);

      const relativeStartPath = targetStartParts.slice(moveStartParts.length);
      const relativeEndPath = targetEndParts.slice(moveStartParts.length);

      const newStartParts = [...endPathParts, ...relativeStartPath];
      const newEndParts = [...endPathParts, ...relativeEndPath];

      const finalResult = {
        start: buildPath(newStartParts),
        end: buildPath(newEndParts)
      };

      console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - MOVE final result:', finalResult);
      return finalResult;
    }

    const targetParts = parsePath(result.start);
    const deletedParts = parsePath(deleteItem.selectorPath);
    let ancestorMoveInfo = null;

    if (deletedParts.length < targetParts.length) {
      let isPrefix = true;
      for (let i = 0; i < deletedParts.length; i++) {
        if (i >= targetParts.length ||
          targetParts[i].tag !== deletedParts[i].tag ||
          targetParts[i].index !== deletedParts[i].index) {
          isPrefix = false;
          break;
        }
      }
      if (isPrefix) {
        ancestorMoveInfo = {
          prefixLength: deletedParts.length,
          remainingPath: targetParts.slice(deletedParts.length)
        };
        console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - ancestor move detected, prefixLength:', ancestorMoveInfo.prefixLength, 'remainingPath:', ancestorMoveInfo.remainingPath);
      }
    }

    let intermediateResult = { ...result };

    if (ancestorMoveInfo) {
      console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - ancestor move, skipping delete shifts on target');
    } else if (deleteShifts.length > 0) {
      const startParts = parsePath(result.start);
      let newStartParts = [...startParts];
      for (const shift of deleteShifts) {
        const partIdx = startParts.length - 1 - shift.leafIdx;
        if (partIdx >= 0 && partIdx < newStartParts.length) {
          newStartParts[partIdx].index += shift.delta;
          if (newStartParts[partIdx].index < 1) newStartParts[partIdx].index = 1;
        }
      }
      intermediateResult.start = buildPath(newStartParts);

      const endParts = parsePath(result.end);
      let newEndParts = [...endParts];
      for (const shift of deleteShifts) {
        const partIdx = endParts.length - 1 - shift.leafIdx;
        if (partIdx >= 0 && partIdx < newEndParts.length) {
          newEndParts[partIdx].index += shift.delta;
          if (newEndParts[partIdx].index < 1) newEndParts[partIdx].index = 1;
        }
      }
      intermediateResult.end = buildPath(newEndParts);
    }
    console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - intermediate result after delete:', intermediateResult);

    console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - using end_path directly (already post-move):', newItem.end_path);

    const addItem = {
      type: 'add',
      start_path: newItem.end_path,
      end_path: newItem.end_path
    };
    console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - adding at:', addItem.start_path);

    let finalResult = { ...intermediateResult };

    if (ancestorMoveInfo) {
      const newParentParts = parsePath(newItem.end_path);
      const reconstructedParts = [...newParentParts, ...ancestorMoveInfo.remainingPath];
      finalResult.start = buildPath(reconstructedParts);
      finalResult.end = buildPath(reconstructedParts);
      console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - ancestor move, reconstructed path:', finalResult.start);
    } else {
      const addShifts = calculateShifts(intermediateResult.start, addItem);
      console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - addShifts:', addShifts);

      if (addShifts.length > 0) {
        const startParts = parsePath(intermediateResult.start);
        let newStartParts = [...startParts];
        for (const shift of addShifts) {
          const partIdx = startParts.length - 1 - shift.leafIdx;
          if (partIdx >= 0 && partIdx < newStartParts.length) {
            newStartParts[partIdx].index += shift.delta;
            if (newStartParts[partIdx].index < 1) newStartParts[partIdx].index = 1;
          }
        }
        finalResult.start = buildPath(newStartParts);

        const endParts = parsePath(intermediateResult.end);
        let newEndParts = [...endParts];
        for (const shift of addShifts) {
          const partIdx = endParts.length - 1 - shift.leafIdx;
          if (partIdx >= 0 && partIdx < newEndParts.length) {
            newEndParts[partIdx].index += shift.delta;
            if (newEndParts[partIdx].index < 1) newEndParts[partIdx].index = 1;
          }
        }
        finalResult.end = buildPath(newEndParts);
      }
    }

    console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - MOVE final result:', finalResult);
    return finalResult;
  }

  // ============================================================
  // HANDLE ADD/DELETE OPERATIONS
  // ============================================================
  console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - calculating shifts for:', newItem.type);
  const shifts = calculateShifts(result.start, newItem);
  console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - shifts:', shifts);

  if (shifts && shifts.targetDeleted === true) {
    console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - target deleted');
    return { targetDeleted: true };
  }

  if (shifts.length === 0) {
    console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - no shifts, returning unchanged');
    return result;
  }

  const startParts = parsePath(result.start);
  let newStartParts = [...startParts];
  console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - startParts:', startParts);

  for (const shift of shifts) {
    const partIdx = startParts.length - 1 - shift.leafIdx;
    console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - applying shift to start:', shift, 'partIdx:', partIdx);
    if (partIdx >= 0 && partIdx < newStartParts.length) {
      newStartParts[partIdx].index += shift.delta;
      if (newStartParts[partIdx].index < 1) newStartParts[partIdx].index = 1;
    }
  }
  result.start = buildPath(newStartParts);
  console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - updated start:', result.start);

  const endParts = parsePath(result.end);
  let newEndParts = [...endParts];
  console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - endParts:', endParts);

  for (const shift of shifts) {
    const partIdx = endParts.length - 1 - shift.leafIdx;
    console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - applying shift to end:', shift, 'partIdx:', partIdx);
    if (partIdx >= 0 && partIdx < newEndParts.length) {
      newEndParts[partIdx].index += shift.delta;
      if (newEndParts[partIdx].index < 1) newEndParts[partIdx].index = 1;
    }
  }
  result.end = buildPath(newEndParts);
  console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - updated end:', result.end);

  console.log('RECALCULATION RELATED TRACKINGS:: applyChangeToPaths - final result:', result);
  return result;
}

// ============================================================
// recalculateSelector - Main entry point (handles both single and array)
// ============================================================
function recalculateSelector(selectorOrSelectors, editorChanges, isStructural = false, currentLines = null) {
  console.log('[RECALCULATION RELATED TRACKINGS::] recalculateSelector called with:', {
    selectorOrSelectors,
    editorChanges,
    isStructural,
    currentLines
  });

  // Handle array of selectors
  if (Array.isArray(selectorOrSelectors)) {
    console.log(`[RECALCULATION RELATED TRACKINGS::] 📊 Processing array of ${selectorOrSelectors.length} selectors`);

    let currentSelectors = [...selectorOrSelectors];

    for (const change of editorChanges) {
      currentSelectors = applyChangeToPathsToArrayOfTargetSelectors(currentSelectors, change);
    }

    // Filter out invalid selectors and normalize
    const validSelectors = currentSelectors
      .filter(s => s && s.start && s.end)
      .map(s => normalizeSelector(s));
    
    console.log(`[RECALCULATION RELATED TRACKINGS::] ✅ Processed ${validSelectors.length} selectors`);
    return validSelectors;
  }

  // Handle single selector
  if (!selectorOrSelectors) {
    return null;
  }

  // Normalize the selector
  const normalized = normalizeSelector(selectorOrSelectors);
  if (!normalized) {
    return selectorOrSelectors;
  }

  let startPath = normalized.start || '';
  let endPath = normalized.end || '';
  let loopSelector = normalized.loopSelector || '';
  let changesApplied = 0;

  for (const change of editorChanges) {
    const input = {
      start: startPath,
      end: endPath,
      ...(loopSelector ? { loopSelector: loopSelector } : {})
    };
    
    const result = applyChangeToPaths(input, change);

    if (result && result.targetDeleted === true) {
      return { ...selectorOrSelectors, deleted: true };
    }

    if (result && result.start !== undefined && result.start !== startPath) {
      startPath = result.start;
      changesApplied++;
    }
    if (result && result.end !== undefined && result.end !== endPath) {
      endPath = result.end;
      changesApplied++;
    }
    if (result && result.loopSelector !== undefined && result.loopSelector !== loopSelector) {
      loopSelector = result.loopSelector;
      changesApplied++;
    }
  }

  if (changesApplied === 0) {
    return selectorOrSelectors;
  }

  // Return in new format
  const result = {
    start: startPath,
    end: endPath
  };
  
  if (loopSelector) {
    result.loopSelector = loopSelector;
  }

  return result;
}

function findElementByPath(htmlString, elementPath) {
  console.log('RECALCULATION RELATED TRACKINGS:: findElementByPath called with:', { htmlString, elementPath });
  if (typeof DOMParser === 'undefined') {
    return null;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');

  const parts = parsePath(elementPath);
  if (parts.length === 0) return null;

  let currentElement = doc.body;

  for (const part of parts) {
    if (!currentElement) return null;

    const children = Array.from(currentElement.children)
      .filter(el => el.tagName.toLowerCase() === part.tag);

    if (part.index > 0 && part.index <= children.length) {
      currentElement = children[part.index - 1];
    } else {
      return null;
    }
  }

  return currentElement;
}

function validateSelector(htmlString, selector) {
  console.log('RECALCULATION RELATED TRACKINGS:: validateSelector called with:', { htmlString, selector });
  if (!selector) {
    return { valid: false, reason: 'Invalid selector' };
  }

  const normalized = normalizeSelector(selector);
  if (!normalized || !normalized.start || !normalized.end) {
    return { valid: false, reason: 'Invalid selector format' };
  }

  const startElement = findElementByPath(htmlString, normalized.start);
  const endElement = findElementByPath(htmlString, normalized.end);

  if (!startElement) {
    return { valid: false, reason: 'Start element not found' };
  }

  if (!endElement) {
    return { valid: false, reason: 'End element not found' };
  }

  return { valid: true };
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    parsePath,
    buildPath,
    SelectorTracker,
    calculateShifts,
    applyChangeToPaths,
    applyChangeToPathsToArrayOfTargetSelectors,
    calculateShiftsForLoopSelector,
    recalculateSelector,
    findElementByPath,
    validateSelector,
    getSelectorPath,
    normalizeSelector
  };
} else {
  window.SelectorRecalculator = {
    parsePath,
    buildPath,
    SelectorTracker,
    calculateShifts,
    applyChangeToPaths,
    calculateShiftsForLoopSelector,
    applyChangeToPathsToArrayOfTargetSelectors,
    recalculateSelector,
    findElementByPath,
    validateSelector,
    getSelectorPath,
    normalizeSelector
  };
}